import React, { useMemo } from 'react'
import OrganizeAttrs from './OrganizeAttrs'
import GroupAttributeView from './GroupAttributeView'

export default function AttributeTreeView( props ) {

  const { blueprint, tags } = props

  const organizeAttrs = useMemo( () => {
    let r = blueprint.attributes || []
    if ( tags.length > 0 ) {
      r = r.filter( ( a ) => {
        return tags.some( ( t ) => { return a.path.indexOf( t ) >= 0 || a.name.indexOf( t ) >= 0 } )
      } )
    }
    return OrganizeAttrs.organizeAttrs( r )
  }, [ blueprint.attributes, tags ] )

  return (
    <div>
      <GroupAttributeView {...props} node={organizeAttrs} />
    </div>
  )

}
